<template>
  <div>
    <v-slide-y-transition mode="out-in">
      <!-- A spinner to indicate that the app is loading the pivot items -->
      <v-layout v-if="loadingPivotItems" justify-center>
        <v-flex shrink>
          <v-loading-message message="Cargando pivote" />
        </v-flex>
      </v-layout>
      <!-- The real component -->
      <div v-else-if="pivotItems.length">
        <!-- The row with the arrows and the item -->
        <v-layout align-center>
          <!-- The item card -->
          <v-flex class="px-2" shrink>
            <v-item-card v-if="pivotItems.length" hide-header :item="pivotItems[0]" vertical />
          </v-flex>
        </v-layout>
        <!-- The indicator of the page -->
        <v-layout class="my-3" justify-center>
          <!-- Previous item -->
          <v-flex shrink>
            <v-btn @click="page = page - 1" :disabled="page <= 1" icon>
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
          </v-flex>
          <!-- The page selector -->
          <v-flex shrink>
            <v-page-selector v-model="page" :total="pivotItemsTotal" />
          </v-flex>
          <!-- Next item -->
          <v-flex shrink>
            <v-btn @click="page = page + 1" :disabled="page == pivotItemsTotal" icon>
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <!-- A message to show when there is no pivot -->
      <v-layout v-else class="mt-5" justify-center>
        <v-flex class="blue-grey--text" shrink>No hay items sin QMP que mostrar.</v-flex>
      </v-layout>
    </v-slide-y-transition>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

import VItemCard from "../../components/ItemCard";
import VLoadingMessage from "../../components/LoadingMessage";
import VPageSelector from "@/components/pagination/PageSelector";

export default {
  components: {
    VItemCard,
    VLoadingMessage,
    VPageSelector
  },
  computed: {
    ...mapState("matching", [
      "pivotItems",
      "pivotItemsFetch",
      "pivotItemsOffset",
      "pivotItemsTotal",
      "loadingPivotItems"
    ]),
    brand() {
      return this.$route.params.brandName;
    },
    classificationId() {
      return this.$route.params.classificationId;
    },
    page: {
      get() {
        return this.pivotItemsOffset + 1;
      },
      set(page) {
        this.setPivotItemsOffset(page - 1);
      }
    }
  },
  watch: {
    page() {
      this.getPivotItems({
        brand: this.brand,
        classificationId: this.classificationId
      });
    }
  },
  created() {
    if (!this.loadingPivotItems) {
      this.getPivotItems({
        brand: this.brand,
        classificationId: this.classificationId,
        page: 1
      });
    }
  },
  methods: {
    ...mapActions("matching", ["getPivotItems"]),
    ...mapMutations("matching", ["setPivotItemsOffset"])
  }
};
</script>
